export function dynamicSort(
  property: string,
  nestedProperty: string,
  sort: SortDirection
) {
  let sortOrder = sort === "asc" ? 1 : -1;
  return function (a: any, b: any) {
    let result = nestedProperty
      ? a[property][nestedProperty] < b[property][nestedProperty]
        ? -1
        : a[property][nestedProperty] > b[property][nestedProperty]
        ? 1
        : 0
      : a[property] < b[property]
      ? -1
      : a[property] > b[property]
      ? 1
      : 0;
    return result * sortOrder;
  };
}

export type SortDirection = "asc" | "desc";

export function dynamicSortMultiple() {
  /*
   * save the arguments object as it will be overwritten
   * note that arguments object is an array-like object
   * consisting of the names of the properties to sort by
   */
  let props = arguments;
  return function (obj1: any, obj2: any) {
    let i = 0,
      result = 0,
      numberOfProperties = props.length;
    /* try getting a different result from 0 (equal)
     * as long as we have extra properties to compare
     */
    while (result === 0 && i < numberOfProperties) {
      result = dynamicSort(props[i], "", "asc")(obj1, obj2);
      i++;
    }
    return result;
  };
}

export const arrayContainsObjectByKey = (
  array: any[],
  obj: any,
  key: string
) => {
  return array.some((elem) => elem[key] === obj[key]);
};

export function getArrayItemByKey(key: string, array: Array<any>): any {
  const filteredArray = array.filter((item) => item.key === key);
  if (filteredArray.length === 1) {
    return filteredArray[0];
  } else {
    return null;
  }
}

export function arrayUnionStringArray(string: string, array: string[]) {
  if (array.includes(string)) {
    return array;
  } else {
    return [...array, string];
  }
}

export function removeDuplicatesFromArray(
  arr: Array<any>,
  key: string
): Array<any> {
  if (!arr) {
    return [];
  } else {
    return arr.reduce(
      function (p, c) {
        // create an identifying id from the object values
        let id = [c[key], c[key]].join("|");

        // if the id is not found in the temp array
        // add the object to the output array
        // and add the key to the temp array
        if (p.temp.indexOf(id) === -1) {
          p.out.push(c);
          p.temp.push(id);
        }
        return p;

        // return the deduped array
      },
      { temp: [], out: [] }
    ).out;
  }
}

export function getRandomItemFromArray(items: Array<any>) {
  return items[Math.floor(Math.random() * items.length)];
}

export function findItemByIndex(
  key: string,
  value: any,
  array: Array<any>
): any {
  let i;
  for (i = 0; i < array.length; i++) {
    if (array[i][key] === value) return array[i];
  }
  return null;
}

export const findDuplicates = (key: string, list: any[]) => {
  let dupes: any = {};
  list.forEach((item, index) => {
    dupes[item[key]] = dupes[item[key]] || [];
    dupes[item[key]].push(index);
  });
  return dupes;
};

export const permissionSorting: string[] = [
  "admin",
  "premium",
  "partner",
  "basic",
];

export function mapOrder(array: any[], order: string[], key: string) {
  const orderedArray = array.slice().sort(function (a, b) {
    const A = a[key],
      B = b[key];
    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });
  return orderedArray;
}

export function arePermissionsTheSame(x: any[], y: any[]) {
  if (!x || !y) {
    return true;
  }
  if (x.length !== y.length) {
    return false;
  } else if (x.length === 0 && y.length === 0) {
    return true;
  }

  const array1 = mapOrder(x, permissionSorting, "access_level");
  const array2 = mapOrder(y, permissionSorting, "access_level");

  let permissionsAreSame = true;
  array1.forEach((item, index) => {
    if (!areObjectsTheSame(array1[index], array2[index])) {
      permissionsAreSame = false;
    }
  });
  return permissionsAreSame;
}

export function areObjectsTheSame(x: any, y: any) {
  let objectsAreSame = true;
  for (const propertyName in x) {
    if (x[propertyName] !== y[propertyName]) {
      objectsAreSame = false;
      break;
    }
  }
  return objectsAreSame;
}

export const chunkArray = (array: Array<any>, size: any): Array<Array<any>> => {
  const chunked_arr = [];
  const copied = [...array]; // ES6 destructuring
  const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
  for (let i = 0; i < numOfChild; i++) {
    chunked_arr.push(copied.splice(0, size));
  }
  return chunked_arr;
};
